import { render, staticRenderFns } from "./SearchResponsavel.vue?vue&type=template&id=1504fda0&"
import script from "./SearchResponsavel.vue?vue&type=script&lang=ts&"
export * from "./SearchResponsavel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports